import { graphql } from '@/generated/gql';

export const COUNTRY_REPORT_TABLE_QUERY = graphql(/* GraphQL */ `
  query CountryReportTable($id: UUID!) {
    cataclysm {
      countryReport(id: $id) {
        id
        dimensions {
          id
          name
        }
        values {
          dimensionId
          value
          countryCode
        }
      }
    }
  }
`);
